import {Component, NgZone, OnInit} from '@angular/core';
import {Settings, Themes} from '@orga-app/settings/settings.model';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import * as actionsUi from './einstellungen.actions.ui';
import {select, Store} from '@ngrx/store';
import * as fromEinstellungenPage from './einstellungen.reducer';
import {Observable} from 'rxjs';
import {SafeUrl} from '@angular/platform-browser';
import {ThemeRefreshAction, ThemeReloadImagesAction} from '@orga-app/settings/actions';
import {Benutzer, BenutzerEinstellungen, BenutzerverwaltungBenutzerZugriff} from '../../clients/benutzerverwaltung';
import {getBenutzerEinstellungen, getBenutzerEinstellungenFehler, getBenutzerEinstellungenLaden, getBenutzerListe, getBenutzerListeFehler, getBenutzerListeLaden, getSelectedBenutzer} from './einstellungen.reducer';
import {BenutzerListeLadenAction, BenutzerSelektiertAction} from './einstellungen.actions.ui';
import {ListInputItem} from '../shared/sopi-list/sopi-list.model';
import {getZugriffBenutzerverwaltung} from '../navi/navi.reducer';

declare let window;
declare let themesJson;

@Component({
    selector: 'app-einstellungen',
    templateUrl: './einstellungen.page.html',
    styleUrls: ['./einstellungen.page.scss'],
})
export class EinstellungenPage implements OnInit {
    aktuellerTab = 'Themes';

    selectedTheme: Settings = {};
    selectedThemeValue: string;
    // themes: { 'files': Array<any>, 'names': Array<any> } = themesJson;
    themes$: Observable<Themes>;
    public themeDefault$: Observable<Settings>;
    public logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'EinstellungenPage';

    benutzer$: Observable<Array<ListInputItem>>;
    benutzerLaden$: Observable<boolean>;
    benutzerFehler$: Observable<boolean>;
    selectedBenutzer$: Observable<Benutzer>;

    benutzerEinstellungen$: Observable<BenutzerEinstellungen>;
    benutzerEinstellungenLaden$: Observable<boolean>;
    benutzerEinstellungenFehler$: Observable<boolean>;

    zugriff$: Observable<BenutzerverwaltungBenutzerZugriff>;

    constructor(
        private store: Store<fromEinstellungenPage.PageState>,
        public settings: SettingsProvider,
        ngZone: NgZone
        // @Inject(DOCUMENT) public document: Document
    ) {
        this.themeDefault$ = this.settings.getThemeDefault();
        this.themes$ = this.settings.getThemes();
        this.logoHeaderSVG$ = this.settings.getLogoHeaderSVG();
        this.logoHeaderSVG$.subscribe(x => {
            ngZone.run(() => {
                // console.log(x);
            });
        });
        this.settings.getActiveTheme().subscribe(val => {
            ngZone.run(() => {
                this.selectedTheme = val;
                this.selectedThemeValue = (val) ? val.value : null;
            });
        });

        this.benutzer$ = this.store.pipe(select(getBenutzerListe));
        this.benutzerLaden$ = this.store.pipe(select(getBenutzerListeLaden));
        this.benutzerFehler$ = this.store.pipe(select(getBenutzerListeFehler));

        this.selectedBenutzer$ = this.store.pipe(select(getSelectedBenutzer));

        this.benutzerEinstellungen$ = this.store.pipe(select(getBenutzerEinstellungen));
        this.benutzerEinstellungenLaden$ = this.store.pipe(select(getBenutzerEinstellungenLaden));
        this.benutzerEinstellungenFehler$ = this.store.pipe(select(getBenutzerEinstellungenFehler));

        this.zugriff$ = this.store.pipe(select(getZugriffBenutzerverwaltung));
    }

    ngOnInit() {
        console.debug('ngOnInit EinstellungenPage');
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    async setAppTheme(theme: Settings) {
        this.settings.setActiveTheme(theme);
        this.store.dispatch(new ThemeReloadImagesAction());
        // this.settings.reloadImages();

        // TODO: Da Modale, Alert Fenster, Datepicker u.s.w. sich außerhalb von <ion-app> platzieren, schreibe ich die Theme Klasse hier auch in den <body>. Funktioniert zwar, aber geht technisch bestimmt eleganter!
        // const classList = this.document.body.classList;
        // const currentTheme = classList.toString().match(/\b(\w*theme-)\S*\b/g);
        // if (currentTheme) {
        //     this.document.body.classList.remove(currentTheme.toString());
        // }
        // this.document.body.classList.add(theme.value);
        // plt-desktop md hydrated


        const classList = window.document.body.classList;
        const currentTheme = classList.toString().match(/\b(\w*theme-)\S*\b/g);
        // console.debug(theme);
        // console.debug(currentTheme);
        if (currentTheme) {
            window.document.body.classList.remove(currentTheme.toString());
        }
        window.document.body.classList.add(theme.value);
    }

    async refreshThemes() {
        await this.store.dispatch(new ThemeRefreshAction());
    }

    benutzerLaden() {
        this.store.dispatch(new BenutzerListeLadenAction());
    }

    async benutzerSelektiert(item: Benutzer) {
        this.store.dispatch(new BenutzerSelektiertAction(item));
    }

    setzeTroubleTicketSichtbarAktiv($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeTroubleTicketSichtbarAction($event.detail.checked));
    }

    setzeIncidentManagementSichtbarAktiv($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeIncidentManagementSichtbar($event.detail.checked));
    }
}
